<template>
  <div class="wrapper">
    <header class="header">
      <section class="left">
        <img class="logo" @click="backIndex" src="https://web-data.zmlearn.com/image/gzi8hTxxiTALSr6Mnkb562/Dreamen%20ABC%401x.png" />
        <div class="shouye" @click="backIndex">首页</div>
      </section>
      <section class="right">
        <div class="info" v-if="!token">
          <!-- <el-button type="primary" class="login mr20" @click="loginVisible = true">登录</el-button> -->
          <el-button plain class="register mr20" @click="registerVisible = true">机构入驻</el-button>
          <!-- <el-button plain class="publish" @click="publishVisible = true">信息发布</el-button> -->
        </div>
        <div v-else class="info">
          <el-button type="text" class="tag" v-if="username">{{ username }}</el-button>
          <el-divider direction="vertical" class="divider" v-if="username"></el-divider>
          <el-button type="text" class="tag" @click="logout">退出登录</el-button>
          <el-divider direction="vertical" class="divider"></el-divider>
          <el-button type="text" class="tag" @click="publishVisible = true">信息发布</el-button>
        </div>
      </section>

      <Login
        ref="loginDialog"
        :loginVisible="loginVisible"
        @cancel="loginClose"
        @confirm="loginConfirm"
      />

      <Register
        ref="registerDialog"
        :registerVisible="registerVisible"
        @cancel="registerClose"
        @confirm="registerConfirm"
      />

      <Publish
        ref="publishDialog"
        :publishVisible="publishVisible"
        @cancel="publishClose"
        @confirm="publishConfirm"
      />

      <el-dialog :visible.sync="infoVisible" width="400px" class="infoWrapper" :show-close="false">
        <img style="width: 120px;height: 120px;" src="https://web-data.zmlearn.com/image/cLFbypPvM4MckwaerdDd7y/img_success.png" alt="" srcset="">
        <p style="color: #333333;font-size: 18px;">提交成功</p>
        <p class="info">您的信息正在审核中，审核通过后商务会与您联系</p>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" class="infoBtn" @click="confirmInfo">我知道了</el-button>
        </div>
      </el-dialog>
    </header>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Login from '../components/login.vue'
import Register from '../components/register.vue'
import Publish from '../components/publish.vue'
// import { opPostRequest } from '../utils/request'
export default {
  name: 'LayoutHeader',
  components: {
    Login,
    Register,
    Publish
  },
  data () {
    return {
      // activeIndex: 'index',
      loginVisible: false,
      registerVisible: false,
      publishVisible: false,
      infoVisible: false
    }
  },
  computed: {
    ...mapState(['activeIndex', 'token']),
    username () {
      return localStorage.getItem('USERNAME') || ''
    }
  },
  methods: {
    ...mapActions(['SetActiveIndex', 'SetToken']),
    handleSelect (key, keyPath) {
      console.log(key, keyPath)
      this.$router.push({
        path: `/${keyPath}`
      })
      this.SetActiveIndex(key)
    },
    backIndex () {
      this.$router.push({
        path: '/'
      })
      this.SetActiveIndex('index')
      localStorage.setItem('activeIndex', 'index')
    },
    loginClose () {
      this.$refs.loginDialog.resetForm('loginForm')
      this.$refs.loginDialog.forgetPassText = '忘记密码？'
      this.loginVisible = false
    },
    // 登录
    loginConfirm () {
      this.loginVisible = false
    },
    // 退出登录
    logout () {
      this.$confirm('确定要退出登录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.SetToken('')
        localStorage.setItem('USERNAME', '')
        this.$message({
          type: 'success',
          message: '退出登录成功!'
        })
        location.href = '/index'
      }).catch(() => {

      })
    },
    registerClose () {
      this.$refs.registerDialog.resetForm('registerForm')
      this.registerVisible = false
    },
    // 注册
    async registerConfirm (val) {
      // const res = await opPostRequest('/api/operation-activity-center/out/v1/lingxun/register', { ...val })
      // const { code, message, data } = res
      // if (code === '0000' && data) {
      this.$refs.registerDialog.resetForm('registerForm')
      this.registerVisible = false
      this.infoVisible = true
      // this.$message({
      //   type: 'success',
      //   message: '注册成功！'
      // })
      // } else {
      //   this.$message.error({
      //     type: 'error',
      //     message
      //   })
      // }
    },
    publishClose () {
      this.$refs.publishDialog.resetForm('publishForm')
      this.publishVisible = false
    },
    publishConfirm () {
      this.$refs.publishDialog.resetForm('publishForm')
      this.publishVisible = false
    },
    confirmInfo () {
      this.infoVisible = false
    }
  }
}
</script>
<style scoped>
.infoWrapper >>> .el-dialog{
  border-radius: 10px;
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .wrapper{
    height: 90px;
    width: 100%;
    background-color: #fff;
    .header{
      height: 90px;
      width: 1192px;
      margin: 0 auto;
      background-color: #fff;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      .left{
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        .logo{
          height: 48px;
          width: 124px;
          margin: 0 20px 0 20px;
          cursor: pointer;
        }
        .shouye{
          font-family: PingFang SC;
          font-size: 18px;
          font-weight: 550;
          line-height: normal;
          text-align: center;
          color: #333333;
          margin-left: 20px;
          cursor: pointer;
        }
        .menu{
          background-color: transparent;
          margin-left: 50px;
          .menuItem{
            background-color: transparent;
            font-size: 18px;
            font-weight: 500;
            color: #333;
          }
        }
      }
      .right{
        .info{
          font-family: PingFang SC;
          font-size: 16px;
          font-weight: normal;
          line-height: normal;
          text-align: center;
          letter-spacing: 0px;
          font-variation-settings: "opsz" auto;
          color: #999999;
          .login{
            color: #fff;
            background-color: #BC1A33;
            border-color: #BC1A33;
          }
          .register, .publish{
            color: #BC1A33;
            border: 1px solid #BC1A33;
          }
          .tag{
            font-size: 18px;
            font-weight: 500;
            color: #333;
            &.active{
              color: #BC1A33;
            }
          }
          .divider{
            height: 28px;
            margin: 0 20px;
          }
        }
      }
    }
  }
  .dialog-footer{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    .infoBtn{
      width: 150px;
      background-color: #BC1A33;
      border-color: #BC1A33;
      color: #fff;
      font-size: 16px;
      font-weight: 500;
    }
  }
  .el-menu.el-menu--horizontal{
    border-bottom: none;
  }
  .mr20{
    margin-right: 20px;
  }
  .mr32{
    margin-right: 32px;
  }
  .ml32{
    margin-left: 32px;
  }
</style>
